import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const LCD_Interfacing = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="LCD Interfacing with 8051 Microcontroller"
      videos={[
        "https://www.youtube.com/embed/pihAdSek7oM", // LCD interfacing video
      ]}
      takeaways={[
        {
          text: "LCD is more important than LED and is likely to appear in both CAT and FAT exams.",
        },
        {
          text: "Questions often involve displaying messages on the LCD, potentially in different modes.",
        },
        {
          text: "Some questions may combine LCD interfacing with serial communication or mathematical operations.",
        },
        {
          text: "Be prepared for questions that involve displaying values stored in ROM on the LCD.",
        },
      ]}
      questions={[
        "Develop an 8051 assembly program for a 2x16 LCD display. Assume 'VITVELLORE' is stored in ROM starting from 200H. Bring the characters to be displayed in LCD from ROM location starting at 200H.",
        "Design an 8051-based LCD display system with data lines of LCD connected to Port 0 and control signals to Port 1. Develop an assembly language program for the same system to display 'VIT'. (Note: '38H'-LCD 2 lines 5X7 Matrix; '0EH'-Display ON cursor ON; '01H'-Clear LCD '06H'-Shift cursor right)",
        "Write an 8051 assembly language program to interface a 16x2 LCD by sending Hex code commands '38H, 0EH, 01H, 06H' and display 'VIT Vellore' on it in line 2 position 3. Assume D0-D7, RS, R/W', and E pins of LCD are connected with P1.0-P1.7, P2.0, P2.1, and P2.2 pins of 8051 microcontrollers, respectively.",
      ]}
      exampleVideos={[]} // No extra example videos
    />
  );
}

export default LCD_Interfacing;
